/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForGcpKubernetesUserManagedIndividual extends models.StorageConfigurationForGcpKubernetesUserManaged {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForGcpKubernetesUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForGcpKubernetesUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForGcpKubernetesUserManagedIndividual>): StorageConfigurationForGcpKubernetesUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForGcpKubernetesUserManagedIndividual(), model);
        StorageConfigurationForGcpKubernetesUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForGcpKubernetesUserManagedIndividual>): StorageConfigurationForGcpKubernetesUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForGcpKubernetesUserManagedIndividual.newInstance(<StorageConfigurationForGcpKubernetesUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForGcpKubernetesUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForGcpKubernetesUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForGcpKubernetesUserManagedIndividual): boolean {
        if (models.StorageConfigurationForGcpKubernetesUserManaged.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForGcpKubernetesUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
